<template>
  <th class="align-left" v-if="isHeader">
    {{ title }}
  </th>
  <div v-else-if="rowData">
    <span class="f-s-14">{{ getContainerDetailParam(rowData.container, 'Plate') }}</span
    ><br />
  </div>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {
          container: {
            detail: {
              Plate: '-',
            },
          },
        }
      },
    },
  },
  methods: {
    getContainerDetailParam(container, key) {
      const detail = typeof container === 'string' ? JSON.parse(container) : container.detail
      return detail[key]
    },
  },
  name: 'Plate',
}
</script>

<style src="@/styles/styled_cell.less" lang="less" scoped="true"></style>
